/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".dialog-card[_ngcontent-%COMP%]{max-width:50vw}.dialog-content[_ngcontent-%COMP%]{line-height:1.5rem}"];
export { styles as styles };
